import * as React from 'react';
import {
  MultiSlider as VWMultiSlider,
  Slider as VWSlider,
} from '@volkswagen-onehub/components-core';
import {
  MultiSliderProps,
  SliderProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Slider({
  labelId,
  testId,
  hideValueBubbles = false,
  showIntervals = false,
  hideMinMax = false,
  ...restProps
}: SliderProps): JSX.Element {
  return (
    <VWSlider
      aria-labelledby={labelId}
      fillStyle={restProps.backgroundGradient ? 'none' : 'auto'}
      {...restProps}
      data-testid={testId}
      hideValueBubbles={hideValueBubbles}
      showIntervals={showIntervals}
      hideMinMax={hideMinMax}
    />
  );
}

export function MultiSlider(props: MultiSliderProps): JSX.Element {
  const {minStepBetweenThumbs, labelId, highlight, testId, ...restProps} =
    props;
  const highlights = React.useMemo(
    () => (highlight ? [highlight] : undefined),
    [highlight]
  );

  return (
    <VWMultiSlider
      minRangeBetweenThumbs={minStepBetweenThumbs * restProps.step}
      aria-describedby={labelId}
      rigidThumbs
      highlights={highlights}
      data-testid={testId}
      {...restProps}
    />
  );
}
